export {
  ANNUAL_TRIP_DURATION_YEARS,
  SYSTEM_TRAVEL_DEFAULTS,
  DEFAULT_REGION_FALLBACK,
  ALLOWED_INSURANCE_TYPES,
  MAX_TRAVELLERS,
  MIN_ADULTS,
  MIN_CHILDREN,
} from '@hyphengroup/cms-components/utils/travelInsurance/constants';
